import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

export const TABLE_DEFAULT_STYLES = {
  tableContainer: css({
    backgroundColor: theme.colors.primary.contrastWhite,
    borderRadius: '8px',
  }),
};
